var map = {
	"./culture/chinese-new-year-traditions/metadata.json": 6876,
	"./culture/chinese-tea-culture/metadata.json": 3113,
	"./culture/dragon-dance-traditions/metadata.json": 2991,
	"./culture/lantern-festival-2025/metadata.json": 2907,
	"./culture/mid-autumn-festival-2025/metadata.json": 330,
	"./culture/year-of-snake-2025/metadata.json": 5572,
	"./explore/daocheng-yading/metadata.json": 8361,
	"./explore/jiuzhaigou-valley/metadata.json": 2614,
	"./explore/kanas-lake-xinjiang/metadata.json": 7230,
	"./explore/pingtan-island/metadata.json": 2172,
	"./explore/shangli-ancient-town/metadata.json": 2715,
	"./explore/wuyuan-countryside/metadata.json": 1174,
	"./explore/yangshuo-li-river/metadata.json": 5980,
	"./stories/great-wall-family-history/metadata.json": 6863,
	"./stories/life-changing-china-experience/metadata.json": 7850,
	"./stories/modern-china-traditional-culture/metadata.json": 4609,
	"./stories/tea-culture-bridge/metadata.json": 6128,
	"./stories/teaching-english-rural-china/metadata.json": 8616,
	"./stories/vr-poetry-experience/metadata.json": 3120
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 6741;
module.exports = webpackAsyncContext;